import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  // Auth: la sesión viaja en cookies httpOnly (withCredentials), no en localStorage.
  // Multi-empresa: los links públicos llevan ?c={companyId}; se reenvía al API
  const c = new URLSearchParams(window.location.search).get("c");
  if (c) config.params = { ...(config.params || {}), c };
  return config;
});

export default api;

export const rowKey = () =>
  (window.crypto?.randomUUID ? window.crypto.randomUUID() : `k-${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const fmtMXN = (value) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0);

export const fmtMXNFull = (value) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(value || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    // For YYYY-MM-DD strings, parse as LOCAL date (not UTC) to avoid
    // off-by-one display in zones like America/Mexico_City (UTC-6).
    let d;
    if (typeof iso === "string" && /^\d{4}-\d{2}-\d{2}$/.test(iso)) {
      const [y, m, day] = iso.split("-").map(Number);
      d = new Date(y, m - 1, day);
    } else {
      d = new Date(iso);
    }
    return d.toLocaleDateString("es-MX", {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch {
    return iso;
  }
};

// Returns local date YYYY-MM-DD (NOT UTC). Fixes the off-by-one-day issue when
// capturing late at night in zones like America/Mexico_City (UTC-6).
export const todayLocal = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const ROLES = [
  { value: "admin", label: "Administrador" },
  { value: "residente", label: "Residente" },
  { value: "supervisor", label: "Supervisor" },
  { value: "contador", label: "Contador" },
  { value: "auxiliar", label: "Auxiliar Administrativo" },
  { value: "mecanico", label: "Mecánico" },
];

export const PROJECT_STATUS = [
  { value: "planificacion", label: "Planificación", color: "badge-info" },
  { value: "en_progreso", label: "En Progreso", color: "badge-magenta" },
  { value: "pausado", label: "Pausado", color: "badge-pending" },
  { value: "completado", label: "Completado", color: "badge-success" },
  { value: "cancelado", label: "Cancelado", color: "badge-danger" },
];

export const EXPENSE_STATUS = [
  { value: "pendiente", label: "Pendiente", color: "badge-pending" },
  { value: "aprobado", label: "Aprobado", color: "badge-success" },
  { value: "rechazado", label: "Rechazado", color: "badge-danger" },
  { value: "pagado", label: "Pagado", color: "badge-info" },
];

export const EXPENSE_CATEGORIES = [
  { value: "materiales", label: "Materiales" },
  { value: "mano_obra", label: "Mano de Obra" },
  { value: "destajos", label: "Destajos" },
  { value: "equipo", label: "Equipo" },
  { value: "transporte", label: "Transporte" },
  { value: "servicios", label: "Servicios" },
  { value: "permisos", label: "Permisos" },
  { value: "alimentos", label: "Alimentos" },
  { value: "hospedaje", label: "Hospedaje" },
  { value: "marketing", label: "Marketing" },
  { value: "publicidad", label: "Publicidad" },
  { value: "herramientas", label: "Herramientas" },
  { value: "papeleria", label: "Papelería" },
  { value: "seguridad", label: "Seguridad e Higiene" },
  { value: "otros", label: "Otros" },
];

export const EXPENSE_FUNDED_BY = [
  { value: "empresa", label: "Empresa" },
  { value: "persona", label: "Persona" },
];

export const EXPENSE_PAYMENT_METHODS = [
  { value: "efectivo", label: "Efectivo" },
  { value: "transferencia", label: "Transferencia" },
  { value: "deposito", label: "Depósito" },
  { value: "tarjeta_credito", label: "Tarjeta de crédito" },
  { value: "tarjeta_debito", label: "Tarjeta de débito" },
  { value: "cheque", label: "Cheque" },
  { value: "otro", label: "Otro" },
];

export const ADMIN_EXPENSE_CATEGORIES = [
  { value: "renta_oficina", label: "Renta de oficina" },
  { value: "servicios_oficina", label: "Servicios (luz/agua/internet/tel)" },
  { value: "papeleria", label: "Papelería y consumibles" },
  { value: "honorarios", label: "Honorarios profesionales" },
  { value: "impuestos", label: "Impuestos y derechos" },
  { value: "mantenimiento", label: "Mantenimiento" },
  { value: "viaticos_admin", label: "Viáticos administrativos" },
  { value: "comisiones_bancarias", label: "Comisiones bancarias" },
  { value: "software", label: "Software y suscripciones" },
  { value: "publicidad", label: "Publicidad y marketing" },
  { value: "nomina_administrativa", label: "Nómina administrativa" },
  { value: "otros", label: "Otros" },
];

export const PAYMENT_PERIODS = [
  { value: "semanal", label: "Semanal" },
  { value: "quincenal", label: "Quincenal" },
  { value: "mensual", label: "Mensual" },
];

export const PAYROLL_TYPES = [
  { value: "obra", label: "Obra (vinculada a proyecto)" },
  { value: "administrativa", label: "Administrativa" },
];
